// ⚠️⚠️⚠️⚠️ AUTO GENERATED FILE ⚠️⚠️⚠️⚠️ DO NOT EDIT ⚠️⚠️⚠️⚠️
/* eslint-disable */
// @ts-nocheck
import type * as Types from '@/graphql/schema';

import gql from '@/graphql/gql';
export type NotificationFragment = { __typename?: 'CasinoNotificationNormalNotification', id: string, createTime?: number, isRead?: boolean, type?: string, title?: string, body?: string, link?: string, icon?: string, contentType?: string };

export const NotificationFragmentDoc = gql`
    fragment NotificationFragment on CasinoNotificationNormalNotification {
  id
  createTime
  isRead
  type
  title(
    language: $language
    locale: $locale
    deviceType: $deviceType
    userCurrency: $userCurrency
  )
  body(
    language: $language
    locale: $locale
    deviceType: $deviceType
    userCurrency: $userCurrency
  )
  link(
    language: $language
    locale: $locale
    deviceType: $deviceType
    userCurrency: $userCurrency
  )
  icon(
    language: $language
    locale: $locale
    deviceType: $deviceType
    userCurrency: $userCurrency
  )
  contentType
}
    `;
